import ReactDOM from 'react-dom';
import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import FetchBackend from 'i18next-fetch-backend';
import BackendAdapter from 'i18next-multiload-backend-adapter';
import LanguageDetector from 'i18next-browser-languagedetector';
import { useTranslation, initReactI18next } from 'react-i18next';

import { isUndefined, isNull } from 'lodash';
import { getBlob } from '../api';

const localLanguage = !isUndefined(localStorage.getItem('i18nextLng')) ?
  !isNull(localStorage.getItem('i18nextLng')) ?
    localStorage.getItem('i18nextLng') 
    : 'zh'
  : 'zh';
// let blobData= await getBlob({url:'https://lite.ivymobi.com.cn/cdn//ops_service/2a089013-82bd-4035-96ab-563d91f3abb5.json'})
// console.log("========1111111111==============",blobData)

// let JsonText = await blobData.text();
// var jsonData = JSON.parse(text);
// console.log(jsonData); // 输出转换后的JSON对象

export default i18n;
